import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, retry, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LocalStorageService, SessionStorageService } from '../../shared/services/storage.service';
import { Token } from '../../shared/token';

@Component({
	selector: 'app-ad-sign-in',
	templateUrl: './ad-sign-in.component.html',
	styleUrls: ['./ad-sign-in.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AdSignInComponent implements OnInit, OnDestroy {
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public http: HttpClient,
		private route: ActivatedRoute,
		private router: Router,
		private sessionStorageService: SessionStorageService,
		private localStorageService: LocalStorageService,
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	codeparam: string = '';

	Token: Token | undefined;

	ngOnInit(): void {
		this.Token = undefined;
		this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
			this.codeparam = params['code'];
		});
		this.AquireToken()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: object) => {
				setTimeout(() => {
					this.handleToken(data);
				});
			});
	}

	AquireToken(): Observable<Token> {
		const headers = { 'content-type': 'application/x-www-form-urlencoded' };

		const grant_type = 'authorization_code';
		const client_id = this.sessionStorageService.get('User.ClientId');
		const code = this.codeparam;
		const redirect_uri = window.location.origin + environment.redirectUri;
		const body = new URLSearchParams();
		body.set('grant_type', grant_type);
		body.set('client_id', client_id);
		body.set('code', code);
		body.set('redirect_uri', redirect_uri);

		console.log('aquiring token: ');
		console.log('grant_type', grant_type);
		console.log('client_id', client_id);
		console.log('redirect_uri', redirect_uri);
		console.log('code', this.codeparam);

		return this.http
			.post<Token>(`${environment.oAuthUri}/oauth2/token`, body, {
				headers,
			})
			.pipe(retry(1), catchError(this.handleError));
	}

	handleError(error: { error: { message: string }; status: any; message: any }) {
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		return throwError(() => new Error(errorMessage));
	}

	handleToken(data: any) {
		this.Token = <Token>data;
		const identityjwtdecoded: any = jwtDecode(this.Token.id_token);
		console.log('AD login', identityjwtdecoded);
		this.sessionStorageService.set('AdLogin', 'true');
		const sub = identityjwtdecoded.sub;
		const email = identityjwtdecoded.email;
		if (this.localStorageService.get('User.Email') !== email) {
			this.localStorageService.removeItem('User.Selected.ServiceName');
			this.localStorageService.removeItem('User.Selected.Account');
		}
		this.sessionStorageService.set('User.Email', email);
		this.localStorageService.set('User.Email', email);
		this.sessionStorageService.set(`CognitoIdentityServiceProvider.${this.sessionStorageService.get('User.ClientId')}.LastAuthUser`, sub);
		this.sessionStorageService.set('User.Session.Expire', identityjwtdecoded.exp);

		const prefix = `CognitoIdentityServiceProvider.${this.sessionStorageService.get('User.ClientId')}.${sub}.`;
		this.sessionStorageService.set('User.Authorization', this.Token.access_token);
		this.sessionStorageService.set('User.RefreshToken', this.Token.refresh_token);

		// Added
		if (this.localStorageService.get('User.RememberMe') === 'true') {
			this.localStorageService.set('User.RefreshToken', this.Token.refresh_token);
		}

		this.sessionStorageService.set(`${prefix}accessToken`, this.Token.access_token);
		this.sessionStorageService.set(`${prefix}idToken`, this.Token.id_token);
		this.sessionStorageService.set(`${prefix}refreshToken`, this.Token.refresh_token);
		this.sessionStorageService.set(`${prefix}clockDrift`, '0');
		const deepLink: string | null = localStorage.getItem('User.DeepLink');
		if (deepLink && deepLink !== 'null') {
			void this.router.navigate([deepLink.startsWith('/') ? deepLink.substring(1) : deepLink]);
		} else {
			if (this.sessionStorageService.get('User.InviteToken')) {
				void this.router.navigate(['invite']);
			} else {
				// Maybe place logic relating to permissions setting etc. here? Place functions in auth service?
				void this.router.navigate(['core']);
			}
		}
	}
}
